import Background from "./components/background.js"
import { firestore } from '../firebase';
import RankContainer from "./components/rank_container";
import React, {useState, useEffect} from 'react';
import resultDataSet from '../resultData';
import {useLocation} from "react-router";
import Loading from "./Loading";

function TotalResult(){
    const [rankData, setRankData]=useState([]);
    const [rankArray, setRankArray]=useState([]);
    let resultRef = firestore.collection('Result');
    const [isChecked, setChecked]=useState(false);
    const [myType, setMyType]=useState('');
    const totalCount = window.sessionStorage.getItem("total");
    
    const h1Style = {
        color : '#FFA200'
    }
    useEffect(() => {
        var data = window.sessionStorage.getItem("sort");

        if(isChecked === false && data === null){
        getRankData();
        setChecked(true);
        } else{
            setRankData(data);
        }

        if(rankData!== null){
            setTimeout(() => {
                splitRankData();
            },300);
        }
    });
    
    async function getRankData(){
        var unsortMap = new Map();
        var sortedArray = new Array();
       await resultRef.doc(`fF2LVDgqIHKIjKYbrU6s`).get().then((doc) => {
          if (doc.exists) {
            unsortMap = doc.data().type;
            sortedArray = Object.entries(unsortMap).sort((a,b) => b[1]-a[1]);
            window.sessionStorage.setItem("sort", sortedArray);
            setRankData(sortedArray);
          }
      }).catch((error) => {
          console.log("Error getting document:", error);
      });
    }
      
    function drawRankData (){
        const result = [];
        for (let i = 0; i < 32; i+=2) {
          result.push(<RankContainer key = {i}  type = {convertRankTitle(String(rankArray[i])).title} value = {rankArray[i+1]} total = {totalCount}/>);
        }
        return result;
      };
    
      function splitRankData(){
        var splits =  rankData.toString().split(',');
        setRankArray(splits);
        setMyType(getMyKey());
    }

    function getMyKey(){
        var data = window.sessionStorage.getItem("myKey");
        if(data === null){
        let i;
        for( i = 0; i < 32; i+=2){
           if(`"${rankArray[i]}"` === window.sessionStorage.getItem("result")){     
            window.sessionStorage.setItem("myKey", i/2+1);
            return i/2+1;
        }
        }
        } else{
            return data;
        }        
    }

    function convertRankTitle(data){
        switch(data) {
            case 'entp':
              return resultDataSet.entp;
            case 'enfp':
              return resultDataSet.enfp;
            case 'entj':
              return resultDataSet.entj;
            case 'enfj':
              return resultDataSet.enfj;    
             case 'estp':
              return resultDataSet.estp;
            case 'esfp':
              return resultDataSet.esfp;
            case 'estj':
              return resultDataSet.estj;
            case 'esfj':
              return resultDataSet.esfj;                
            case 'infj':
              return resultDataSet.infj;     
            case 'infp':
              return resultDataSet.infp;     
            case 'intp':
              return resultDataSet.intp;     
            case 'intj':
              return resultDataSet.intj;  
              case 'isfj':
                return resultDataSet.isfj;     
              case 'isfp':
                return resultDataSet.isfp;     
              case 'istp':
                return resultDataSet.istp;     
              case 'istj':
                return resultDataSet.istj;                      
            default:
                return 'no type';
              // code block
          }
    }
    const name = "@ Sewon & Jeonga"

      
    return <Background>
         {rankArray[1] === undefined ? <Loading/>: 
             <div className="total-result-container">
             <div className= "total-result-title" >당신은 한동에서 <span style ={h1Style}>{myType}번째</span>로 <br></br>많은 유형에 속합니다</div>
            <div className= "total-result-graph">{drawRankData()}</div>
            <span className="name-text">{name}</span>
            </div>}
        </Background>
}

export default TotalResult;